import { from, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

import { fetch } from '../../service_broker/fetch';
import { ACTION_SUBMIT_BULK_ACTIONS } from '../../store/state/actions';
import { resolveRestApi } from '../../router/app-router';
import { logAndCatchError } from '../../utils/rxjs-utils';
import { getSubmitData, processHeaders } from '../../store/state/epics/util';
import StateUtils from '../../store/state/utils/state-utils';
import type { Action } from '../../store/state/state-manager';

export const executeSubmitBulkActionRequest = (actionInPayload: Action['payload']) => {
  const { actionID, context, cases, classID } = actionInPayload;
  const { content } = getSubmitData(context, { nonEmptyAndChangedData: true });

  let chunkSizeDivisor = 5;
  try {
    /**
     * expected response structure from "D_pySingleExecutionBulkActionsMeta" DP execution and results are fetch as apart of pyPortalAddOns View is:
     * [
     *    {
     *        "classID": "Rule-Obj-CaseType",
     *        "pyClassName": "TOPAPP-APP-Work-Case1",
     *        "pyList": "CasewideLocalActions1,UpdateRelease" // case-wide action id's
     *     }
     *  ]
     */
    const singleExecutionBulkActionsMeta = StateUtils.getSharedState(
      'D_pySingleExecutionBulkActionsMeta.D_pySingleExecutionBulkActionsMeta.pxResults'
    );

    if (
      singleExecutionBulkActionsMeta
        ?.find((classData: { pyClassName: string }) => classData.pyClassName === classID) // fetch the object related to a class
        ?.pyList.split(',')
        .includes(actionID)
    ) {
      chunkSizeDivisor = 1;
    }
  } catch (e) {
    console.error('Failed to fetch to "D_pySingleExecutionBulkActionsMeta" DP response', e);
  }

  const casesList = cases.map((caseID: string) => ({ ID: caseID }));
  const chunkSize = casesList.length / chunkSizeDivisor;
  const routeKey = ACTION_SUBMIT_BULK_ACTIONS;
  const { reqType, restApi } = resolveRestApi(routeKey, { actionID });
  const requests: any[] = [];
  const casesListLength = casesList.length;

  for (let i = 0; i < casesListLength; i += chunkSize) {
    content.cases = casesList.slice(i, i + chunkSize);
    if (content.cases.length) {
      requests.push(
        from(
          fetch(
            restApi,
            {
              method: reqType,
              body: content
            },
            context
          )
        ).pipe(
          map((response) => {
            const { data, headers } = response;
            return {
              response: data,
              actionInPayload,
              headers: processHeaders({ ...headers })
            };
          }),
          logAndCatchError('Error occurred during ajax call at submitbulkaction Epic : ', context)
        )
      );
    }
  }
  return forkJoin(requests);
};

export default {
  executeSubmitBulkActionRequest
};
